/* El aviso es un bloque oscuro: ink, texto blanco, radio 12 y sombra. Lleva `klavia-dark`
   para que lo que tenga adentro (icono, botón) lea los tokens del scope oscuro. */
.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--s-5);
  width: min(360px, calc(100vw - 2 * var(--s-6)));
  padding: var(--s-5) var(--s-6);
  background: var(--surface-page);
  color: var(--text-strong);
  border-radius: var(--r-panel);
  box-shadow: var(--sh-lg);
  font-family: var(--font-body);
}
.icono {
  display: inline-flex;
  margin-top: var(--s-1);
}
/* El éxito va en cian: es el toque de color secundario sobre el bloque oscuro. */
.toast[data-tone="success"] .icono {
  color: var(--text-accent);
}
.toast[data-tone="info"] .icono {
  color: var(--text-brand);
}
.toast[data-tone="warning"] .icono {
  color: var(--status-warning);
}
.toast[data-tone="danger"] .icono {
  color: var(--status-danger);
}
.textos {
  flex: 1;
  min-width: 0;
}
.titulo {
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  color: var(--text-strong);
}
.mensaje {
  margin-top: var(--s-1);
  font-size: var(--fs-2xs);
  line-height: var(--lh-normal);
  color: var(--text-body);
}
.cerrar {
  display: inline-flex;
  padding: var(--s-1);
  border: none;
  border-radius: var(--r-xs);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
}
@media (hover: hover) {
  .cerrar:hover {
    color: var(--text-strong);
    background: var(--action-quiet-hover);
  }
}
.cerrar:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
